var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<img" + (jade.attr("src", require('./../tip-lightbulb-copy-3.svg'), true, true)) + " width=\"55\" alt=\"\"><div style=\"width:240px;\"><h3>Before sending your application, double check that the reports you requested are included</h3></div><div class=\"dots\"><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('form-step1')\" class=\"dot dot1-button\"></a><a href=\"#\" class=\"dot dot2-button active\"></a><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('form-step3')\" class=\"dot dot3-button\"></a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/forms/tour/first_form/step2.jade
// module id = 769
// module chunks = 0